export enum ReminderOptions {
  SLEEP_DIARY = 'sleepDiary',
}
